/*
 * コレクション/商品ページ下部の page-tabs（比較表タブ）の計測。
 * theme.liquid の LINE CRM CTA 計測と同じく dataLayer + gtag へ送る。
 *
 *   collection_tab_viewed     … タブ群が画面に入った（開封率の母数・1ページ1回）
 *   collection_tab_opened     … タブを能動的にクリックした（既定表示のタブ1は含まない）
 *   collection_tab_link_click … タブ本文内のリンクを踏んだ（商品への送客）
 *
 * 表示切替そのものには一切介入しない（capture フェーズで観測するだけ）。
 */
(function () {
  'use strict';

  function push(name, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (typeof window.gtag === 'function' && !window.google_tag_manager) {
      window.gtag('event', name, payload);
    }
  }

  function label(el) {
    return (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
  }

  // 比較表のリンクは画像だけのものが多く textContent が空になる。
  // その場合は alt / title / URL 末尾で埋めて、GA4 側で行が空にならないようにする。
  function linkLabel(a) {
    var text = label(a);
    if (text) return text;
    var img = a.querySelector('img');
    if (img && img.getAttribute('alt')) return img.getAttribute('alt').trim().slice(0, 80);
    if (a.getAttribute('title')) return a.getAttribute('title').trim().slice(0, 80);
    var href = a.getAttribute('href') || '';
    return href.split('?')[0].split('/').filter(Boolean).pop() || '';
  }

  function context(root) {
    return {
      tabs_context: root.getAttribute('data-sk-tabs-context') || '',
      tabs_owner: root.getAttribute('data-sk-tabs-owner') || '',
      page_path: window.location.pathname
    };
  }

  function init(root) {
    if (root.getAttribute('data-sk-tabs-bound') === '1') return;
    root.setAttribute('data-sk-tabs-bound', '1');

    var pills = Array.prototype.slice.call(root.querySelectorAll('.pill-nav-item'));
    if (!pills.length) return;

    var viewed = false;
    function sendViewed() {
      if (viewed) return;
      viewed = true;
      push('collection_tab_viewed', Object.assign(context(root), {
        tab_count: pills.length,
        tab_titles: pills.map(label).join('|'),
        default_tab: label(pills[0])
      }));
    }

    if (typeof window.IntersectionObserver === 'function') {
      var io = new window.IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            sendViewed();
            io.disconnect();
            return;
          }
        }
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      sendViewed();
    }

    root.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;

      var pill = event.target.closest('.pill-nav-item');
      if (pill && root.contains(pill)) {
        push('collection_tab_opened', Object.assign(context(root), {
          tab_title: label(pill),
          tab_handle: pill.getAttribute('data-handle') || '',
          tab_index: pills.indexOf(pill)
        }));
        return;
      }

      var link = event.target.closest('.tabs-component-content a');
      if (link && root.contains(link)) {
        var pane = link.closest('.tabs-component-content');
        push('collection_tab_link_click', Object.assign(context(root), {
          tab_handle: pane ? (pane.getAttribute('data-handle') || '') : '',
          link_text: linkLabel(link),
          link_url: link.getAttribute('href') || ''
        }));
      }
    }, true);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-sk-tabs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
